/** Payroll's opening section, named once so Payroll and the background warm
 *  share one cache entry per actor and workspace. It carries names, leave and
 *  pay figures, so it is held in memory only. The overview already counts
 *  employees and subcontractors; their registers, and CIS returns, are fetched
 *  in full only once Payroll opens, never by the background warm. */

import { PayrollService } from '../../services/PayrollService';
import type { PayrollOverview } from '../../types/payroll';

export const payrollOverviewRead = (workspaceId: string) => ({
  name: 'payroll/overview',
  load: (): Promise<PayrollOverview> => PayrollService.getOverview(workspaceId),
});
